import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from '../../lib/toast';
import { API, auth, errMsg } from '../organization/finance/shared';

const STATUS_INFO = {
  draft: { label: 'غير منشور', color: 'bg-slate-100 text-slate-500' },
  pending_review: { label: 'بانتظار اعتماد السوبر أدمن', color: 'bg-amber-50 text-amber-700' },
  approved: { label: 'منشور في السوق العام', color: 'bg-emerald-50 text-emerald-700' },
  rejected: { label: 'مرفوض', color: 'bg-red-50 text-red-600' },
};

export default function VenueOwnerPublicPagePage() {
  const { venues, reloadVenues } = useOutletContext();
  const [busyId, setBusyId] = useState(null);

  const togglePublish = async (v) => {
    setBusyId(v.id);
    try {
      await axios.put(`${API}/venues/${v.id}`, { is_public: !v.is_public }, auth());
      toast.success(!v.is_public ? 'تم إرسال الملعب لاعتماد النشر' : 'تم إلغاء نشر الملعب');
      reloadVenues();
    } catch (e) { toast.error(errMsg(e, 'فشل تحديث حالة النشر')); } finally { setBusyId(null); }
  };

  return (
    <div className="space-y-4" data-testid="venue-owner-public-page-page">
      <p className="text-sm text-slate-500">تحكم في ما يظهر لملاعبك في السوق العام لتسيار — نشر أي ملعب يحتاج اعتماد فريق تسيار أولاً.</p>
      {venues.length === 0 ? (
        <p className="rounded-2xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-400" data-testid="venue-owner-public-page-empty">أضف ملعباً أولاً من تبويب «الملاعب والكورتات»</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2" data-testid="venue-owner-public-page-list">
          {venues.map((v) => {
            const status = STATUS_INFO[v.publish_status || 'approved'];
            return (
              <div key={v.id} className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid={`venue-owner-public-card-${v.id}`}>
                {v.image_storage_path && <img src={`${API}/venues/${v.id}/image`} alt={v.name} className="h-32 w-full object-cover" />}
                <div className="p-4">
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <p className="text-sm font-bold text-slate-900">{v.name}</p>
                      <p className="text-xs text-slate-500">{v.city || '—'} • {v.price_per_hour ? `${v.price_per_hour} ر.س/ساعة` : 'بلا سعر أساسي'}</p>
                    </div>
                    <span className={`rounded-full px-2.5 py-1 text-[11px] font-bold ${status.color}`} data-testid={`venue-owner-public-status-${v.id}`}>{status.label}</span>
                  </div>
                  {v.rejection_reason && v.publish_status === 'rejected' && (
                    <p className="mt-2 rounded-lg bg-red-50 p-2 text-xs text-red-600" data-testid={`venue-owner-public-rejection-reason-${v.id}`}>سبب الرفض: {v.rejection_reason}</p>
                  )}
                  <div className="mt-3 flex items-center justify-between">
                    <label className="flex items-center gap-2 text-xs font-semibold text-slate-600">
                      <input type="checkbox" checked={!!v.is_public} disabled={busyId === v.id} onChange={() => togglePublish(v)} data-testid={`venue-owner-public-toggle-${v.id}`} />
                      نشر في السوق العام
                    </label>
                    {v.publish_status === 'approved' && <Link to="/venues" target="_blank" className="text-xs font-bold text-orange-600 hover:underline" data-testid={`venue-owner-public-preview-${v.id}`}>معاينة في السوق ↗</Link>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
